import {UserType} from "@/ts/Enum";
import ActivityMessageBase from "@/ts/ActivityMessageBase";

class MessageBase extends ActivityMessageBase {
    activity_teacher_name: string;
    activity_teacher_id: string;
    grade_id: number;
    grade_name: string;
    class_id: number;
    class_name: string;
    subject_name: string;
    subject_code: string;
    class_section: string;
    year: string;
    lesson_id: string;
    prepare_status: number;
    date: string;
    week: string;
    // 活动消息的接收时间
    received_time: Date;
    // 活动的发起教师的在线状态。 当活动的发起教师在线时，该活动才可以正常进入。 避免出现教师发起活动后异常退出，但是学生还能进入该活动的情况。
    activity_teacher_online_status: boolean;

    constructor(activity_id: string, activity_name: string, activity_type: string,
                instruction_order: number,prepare_status: number,
                garden_id: string, garden_name: string, grade_id: number, grade_name: string,
                class_id: number, class_name: string, class_section: string,
                subject_name: string, subject_code: string,
                activity_teacher_name: string,
                activity_teacher_id: string, year: string, lesson_id: string, date: string, week: string) {
        super(activity_id, activity_name, activity_type,
            instruction_order,garden_id, garden_name)
        this.activity_teacher_name = activity_teacher_name
        this.activity_teacher_id = activity_teacher_id
        this.grade_id = grade_id;
        this.grade_name = grade_name;
        this.class_id = class_id;
        this.class_name = class_name
        this.class_section = class_section
        this.subject_name = subject_name
        this.subject_code = subject_code
        this.year = year
        this.lesson_id = lesson_id
        this.prepare_status = prepare_status
        this.date = date
        this.week = week
        this.received_time = new Date()
        this.activity_teacher_online_status = false
    }
}

class Announcement extends MessageBase {

    constructor(base: MessageBase) {
        super(
            base.activity_id,
            base.activity_name,
            base.activity_type,
            base.instruction_order,
            base.prepare_status,
            base.garden_id,
            base.garden_name, base.grade_id, base.grade_name,
            base.class_id, base.class_name, base.class_section,
            base.subject_code, base.subject_name,
            base.activity_teacher_name,
            base.activity_teacher_id,
            base.year,
            base.lesson_id,
            base.date,
            base.week
        );
    }

    send_announcement_user_info: SendAnnouncementUserInfo;
    announcement_info: AnnouncementInfo;
}

class ChatMessage extends MessageBase {
    constructor(base: MessageBase) {
        super(
            base.activity_id,
            base.activity_name,
            base.activity_type,
            base.instruction_order,
            base.prepare_status,
            base.garden_id,
            base.garden_name, base.grade_id, base.grade_name,
            base.class_id, base.class_name, base.class_section,
            base.subject_code, base.subject_name,
            base.activity_teacher_name,
            base.activity_teacher_id,
            base.year,
            base.lesson_id,
            base.date,
            base.week
        );
    }

    send_message_user_info: SendAnnouncementUserInfo;
    chat_message_info: ChatMessageInfo;
}

class SendAnnouncementUserInfo {
    user_type: UserType;
    user_id: string;
    user_name: string;
    user_img_src: string;
    user_gender: boolean;

    constructor(userType: UserType, user_id: string, user_name: string, user_img_src?: string, user_gender?: boolean) {
        this.user_type = userType;
        this.user_id = user_id;
        this.user_name = user_name;
        this.user_img_src = user_img_src;
        this.user_gender = user_gender;
    }
}

class AnnouncementInfo {
    sending_time: string;
    announcement_content: string;

    constructor(sendingTime: string, announcementContent: string) {
        this.sending_time = sendingTime;
        this.announcement_content = announcementContent;
    }
}

class ChatMessageInfo {
    sending_time: string;
    message_type: string;
    message_content: string;

    constructor(sendingTime: string, messageType: string, messageContent: string) {
        this.sending_time = sendingTime;
        this.message_type = messageType;
        this.message_content = messageContent;
    }
}

export {MessageBase, Announcement, ChatMessage, SendAnnouncementUserInfo, AnnouncementInfo, ChatMessageInfo}
